var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83398 12.2388V16.9181C5.83398 18.0498 6.40042 19.1052 7.3413 19.7312L9.25764 21.006C11.5246 22.5133 14.4748 22.5133 16.7406 21.006L18.6569 19.7312C19.599 19.1052 20.1642 18.0486 20.1642 16.9181V12.2388",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 12.2388V16.9181C5.83398 18.0498 6.40042 19.1052 7.3413 19.7312L9.25764 21.006C11.5246 22.5133 14.4748 22.5133 16.7406 21.006L18.6569 19.7312C19.599 19.1052 20.1642 18.0486 20.1642 16.9181V12.2388",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2597 2.57349L2.89722 6.66376C1.34936 7.52355 1.34936 9.74874 2.89722 10.6085L10.2597 14.6988C11.9626 15.6444 14.0339 15.6444 15.738 14.6988L23.1005 10.6085C24.6484 9.74874 24.6484 7.52355 23.1005 6.66376L15.738 2.57349C14.0339 1.62785 11.9638 1.62785 10.2597 2.57349Z",
    fill: "#3158F2",
    stroke: "#DCE3F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.b2c62bfd6f6986cfb60128cec783a4ec.svg";
export { ForwardRef as ReactComponent };